import { TTypeOfCodec } from "../../shared/src/codecs/codec";
import { literal } from "../../shared/src/codecs/types/literal";
import { union } from "../../shared/src/codecs/types/union";

export const PifRiskRuleCode = union([
    literal("pif_neighbour_dispute"),
    literal("pif_legal_action"),
    literal("pif_antisocial_behaviour"),
    literal("pif_noise_issues"),
    literal("pif_extension_approval_missing"),
    literal("pif_extension_approval_partial"),
    literal("pif_extension_approval_unknown"),
    literal("pif_loft_conversion"),
    literal("pif_walls_removed"),
    literal("pif_change_of_use"),
    literal("pif_planning_notices"),
    literal("pif_building_control_notices"),
    literal("pif_environmental_notices"),
    literal("pif_japanese_knotweed"),
    literal("pif_flooding"),
    literal("pif_subsidence"),
    literal("pif_asbestos"),
    literal("pif_coastal_erosion"),
    literal("pif_listed_building"),
    literal("pif_insurance_claims"),
    literal("pif_insurance_refused"),
    literal("pif_boundary_disputes"),
    literal("pif_rights_of_way"),
    literal("pif_informal_arrangements"),
    literal("pif_contamination"),
    literal("pif_pest_issues"),
    literal("pif_damp_issues"),
    literal("pif_owners_disagree"),
    literal("pif_title_restrictions"),
    literal("pif_boundaries_dont_match_title"),
    literal("pif_tenants_in_property"),
    literal("pif_occupiers_wont_vacate"),
    literal("pif_in_chain"),
    literal("pif_dependent_purchase_searching"),
    literal("pif_dependent_purchase_offer_made"),
    literal("pif_dependent_purchase_other"),
    literal("pif_short_lease"),
    literal("pif_low_epc_rating"),
    literal("pif_green_deal"),
    literal("pif_non_mains_drainage"),
    literal("pif_services_crossing"),
    literal("pif_commercial_use"),
    literal("pif_spray_foam_insulation"),
    literal("pif_building_safety_remediation_required"),
    literal("pif_mines_and_minerals"),
    literal("pif_chancel_liability"),
    literal("pif_party_wall_notice"),
    literal("pif_planning_or_buildreg_breach"),
    literal("pif_failed_transactions"),
    literal("pif_crime_or_death_at_property"),
    literal("pif_authority_notified_safety_issue"),
    literal("pif_council_tax_band_change_pending"),
]);
export type TPifRiskRuleCodeCodec = typeof PifRiskRuleCode;
export type TPifRiskRuleCode = TTypeOfCodec<TPifRiskRuleCodeCodec>;

export const PifRiskSeverity = union([
    literal("red"),
    literal("amber"),
]);
export type TPifRiskSeverityCodec = typeof PifRiskSeverity;
export type TPifRiskSeverity = TTypeOfCodec<TPifRiskSeverityCodec>;
